import PrimaryPalette from '../../../colors';

export const IconButtonTheme = {
  iconColor: PrimaryPalette.mediumEvergreen,
  hover: {
    backgroundColor: PrimaryPalette.lighterIris,
  },
  active: {
    backgroundColor: PrimaryPalette.lightGrey,
  },
};
